import { BaseService } from '../../infra/base.service'
import type { AppointmentConsumption } from '../appointments/appointment-consumption'
import type { AppointmentConsumptionRepository } from './appointment-consumption.repository'

export class AppointmentConsumptionService extends BaseService<AppointmentConsumption> {
    constructor(private rep: AppointmentConsumptionRepository) {
        super(rep)
    }

    async findFailedSync(): Promise<AppointmentConsumption[]> {
        return await this.rep.getAll({ syncStatus: 'failed' })
    }

    async comissionsChangeStatus(appointmentConsumptionId: string, active: boolean) {
        return await this.rep.comissionsChangeStatus(appointmentConsumptionId, active)
    }
}
